export default {
  1: [
    {
      icon: 'mdi-briefcase-account-outline',
      title: 'Daftar Riwayat Hidup (CV)',
      subtitle: '(Langkah 1)',
      desc: 'Pada langkah ini Anda diharuskan melengkapi semua informasi Biodata Diri Anda',
      color: 'green',
      deepColor: '',
      akses: true,
      // disable: true,
      key: 'cv',
      action: 'cv',
    },
    {
      icon: 'mdi-square-edit-outline',
      title: 'Esai',
      subtitle: '(Langkah 2)',
      desc: 'Pada langkah ini Anda diharuskan menyelesaikan semua pertanyaan Esai yang telah disediakan',
      color: 'orange',
      deepColor: '',
      akses: true,
      // disable: true,
      key: 'esai',
      action: 'esai',
    },
    // {
    //   icon: 'mdi-brain',
    //   title: 'Tes Bakat Skolastik <br>Susulan/Ulang',
    //   subtitle: '(Langkah 3)',
    //   desc: `Pada langkah ini Anda diharuskan untuk menjawab tes yang telah disediakan -
    //         <b>menunggu jadwal dari Pusat</b>`,
    //   color: 'blue',
    //   deepColor: '',
    //   akses: true,
    //   disable: true,
    //   key: 'tbs',
    //   action: 'tbs',
    // },
    {
      icon: 'mdi-brain',
      title: '<b><u>Uji Coba</u></b> Tes Bakat Skolastik',
      subtitle: '(8 Maret 2020)',
      desc:
        'Pelaksanaan <strong>uji coba</strong> Tes Bakat Skolastik ini ' +
        'akan tersedia pada tanggal <strong>8 Maret November 2020 (Jam 08.00 - 16.00 WIB)</strong>',
      color: 'purple',
      deepColor: '',
      akses: false,
      disable: true,
      key: 'tbs-demo',
      action: 'tbs-demo',
    },
    {
      key: 'diklat',
      icon: 'mdi-google-classroom',
      title: 'Diklat PSP',
      desc: 'Tautan menuju Laman Diklat Program Sekolah Penggerak',
      color: 'primary',
      deepColor: '',
      akses: true,
      href: '#LMS_URL#',
    },
    {
      key: 'kinerja',
      icon: 'mdi-format-list-checks',
      title: 'Evaluasi Kinerja',
      desc:
        'Modul evkin ini digunakan untuk menilai terhadap kinerja yang telah dilakukan oleh setiap peran dalam Program Sekolah Penggerak terhadap peran lainnya.',
      color: 'indigo darken-1',
      deepColor: '',
      akses: false,
      disable: false,
      link: 'kinerja',
      to: { name: 'kinerja' },
    },
    {
      key: 'dkp-pa',
      icon: 'mdi-google-classroom',
      title: 'Laporan PMO & Pendampingan Individu',
      desc: 'Kelola Kelompok Pendampingan oleh PA',
      color: 'indigo',
      deepColor: '',
      akses: false,
      to: { name: 'pendampingan' },
    },
    {
      icon: 'mdi-file-check-outline',
      title: 'Laporan PMO Sekolah',
      subtitle: '',
      desc: 'Laporan Berkala kegiatan PMO',
      color: 'orange',
      deepColor: 'darken-1',
      akses: false,
      key: 'laporan-pmo-sekolah',
      link: 'laporan-pmo-sekolah',
      to: { name: 'laporan-pmo-sekolah' },
    },
    {
      icon: 'mdi-file-clock-outline',
      title: 'Laporan Pelaksanaan IHT',
      subtitle: '',
      desc: 'Laporan Berkalan dan Laporan Pelaksanaan',
      color: 'indigo',
      deepColor: 'darken-1',
      akses: false,
      key: 'iht',
      disable: false,
      action: 'iht',
    },
    {
      icon: 'mdi-google-classroom',
      title: 'Kelola Pendampingan oleh IN',
      subtitle: 'Instruktur ad Interim',
      desc: 'Kelola Kelompok Pendampingan Komite Pembelajar',
      color: 'indigo',
      deepColor: '',
      akses: false,
      key: 'diklat-kp',
      link: 'diklat-kp',
      to: { name: 'diklat-pendampingan' },
    },
    {
      icon: 'mdi-file-clock-outline',
      title: 'Laporan Pelaksanaan IHT',
      subtitle: '',
      desc: 'Laporan Berkalan dan Laporan Pelaksanaan',
      color: 'indigo',
      deepColor: 'darken-1',
      akses: false,
      key: 'diklat-iht',
      disable: false,
      action: 'diklat-iht',
    },

    {
      key: 'lokakarya-gtk',
      icon: 'mdi-account-group',
      title: 'Laporan Pendampingan Kelompok',
      desc: 'Kelola Laporan Pendampingan Kelompok',
      color: 'orange',
      deepColor: '',
      akses: true,
      to: { name: 'kp-lokakarya' },
    },
    {
      key: 'laporan-lingkup-pendidikan',
      icon: 'mdi-account-group',
      title: 'Laporan Lingkup Satuan Pendidikan',
      subtitle: 'Sekolah Penggerak',
      desc: 'Kelola Laporan Lingkup Satuan Pendidikan',
      color: 'orange',
      deepColor: 'darken-2',
      akses: false,
      to: { name: 'laporan-lingkup-pendidikan' },
    },
    {
      key: 'pkp-peserta',
      icon: 'mdi-account-multiple',
      title: 'Daftar Guru dan Pengawas',
      subtitle: 'Sekolah Anda',
      desc:
        'Persiapan daftar Guru dan Pengawas sebagai perwakilan dari Sekolah untuk mengikuti Pelatihan Komite Pembelajaran (PKP)',
      color: 'green',
      deepColor: 'lighten-1',
      btnText: 'Cek Daftar Guru dan Pengawas',
      akses: false,
      link: 'pkp-peserta',
      to: { name: 'pkp-peserta' },
    },
    {
      key: 'pengimbasan-peserta',
      icon: 'mdi-account-multiple',
      title: 'Peserta Pelatihan Pengimbasan',
      subtitle: 'Sekolah Anda',
      desc: 'Pemilihan data Guru sebagai perwakilan dari Sekolah untuk mengikuti Pelatihan Pengimbasan',
      color: 'blue',
      deepColor: 'lighten-1',
      akses: false,
      link: 'pengimbasan-peserta',
      to: { name: 'pengimbasan-peserta' },
    },
    {
      key: 'modul-pengimbasan',
      icon: 'mdi-file-document-multiple',
      title: 'Modul dan Materi Pengimbasan',
      desc: 'Daftar Modul dan Materi Pengimbasan',
      color: 'purple darken-1',
      deepColor: '',
      akses: false,
    },
    {
      key: 'sertifikat',
      icon: 'mdi-certificate-outline',
      title: 'Daftar Sertifikat',
      desc: 'Daftar Sertifikat',
      color: 'success',
      deepColor: '',
      akses: false,
      link: 'sertifikat',
      to: { name: 'sertifikat' },
    },
    {
      icon: 'mdi-web',
      title: 'Portal Sekolah Penggerak',
      desc: '',
      color: 'secondary',
      deepColor: 'darken-2',
      dividerTop: true,
      sidebar: true,
      akses: true,
      newtab: true,
      href: '#PORTAL_URL#',
    },
    {
      icon: 'mdi-webhook',
      title: 'ke Aplikasi SIMPKB',
      desc: '',
      color: 'secondary',
      deepColor: 'darken-2',
      sidebar: true,
      akses: true,
      link: 'app-sim-pkb',
      href: '#SIM_PKB_URL#',
    },
  ],
  2: [
    {
      icon: 'mdi-teach',
      title: 'Simulasi & Wawancara',
      subtitle: '',
      desc: '',
      color: 'pink',
      deepColor: 'darken-1',
      akses: true,
      key: 'microteaching',
      disable: false,
      action: 'microteaching',
    },
    {
      icon: 'mdi-file',
      title: 'Surat Pernyataan Atasan',
      subtitle: '',
      desc: 'Pada langkah ini Anda diharuskan melengkapi dokumen surat pernyataan atasan',
      color: 'blue',
      deepColor: 'darken-1',
      akses: false,
      key: 'atasan',
      disable: false,
      to: { name: 'pimpinan' },
    },
    {
      key: 'diklat',
      icon: 'mdi-google-classroom',
      title: 'Diklat PSP',
      desc: 'Tautan menuju Laman Diklat Program Sekolah Penggerak',
      color: 'primary',
      deepColor: '',
      akses: true,
      href: '#LMS_URL#',
    },
    {
      key: 'kinerja',
      icon: 'mdi-format-list-checks',
      title: 'Evaluasi Kinerja',
      desc:
        'Modul evkin ini digunakan untuk menilai terhadap kinerja yang telah dilakukan oleh setiap peran dalam Program Sekolah Penggerak terhadap peran lainnya.',
      color: 'indigo darken-1',
      deepColor: '',
      akses: false,
      disable: false,
      link: 'kinerja',
      to: { name: 'kinerja' },
    },
    {
      icon: 'mdi-file-check-outline',
      title: 'Laporan PMO Sekolah',
      subtitle: '',
      desc: 'Laporan Berkala kegiatan PMO',
      color: 'orange',
      deepColor: 'darken-1',
      akses: false,
      key: 'laporan-pmo-sekolah',
      link: 'laporan-pmo-sekolah',
      to: { name: 'laporan-pmo-sekolah' },
    },
    {
      icon: 'mdi-file-clock-outline',
      title: 'Laporan Pelaksanaan IHT',
      subtitle: '',
      desc: 'Laporan Berkalan dan Laporan Pelaksanaan',
      color: 'indigo',
      deepColor: 'darken-1',
      akses: false,
      key: 'iht',
      disable: false,
      action: 'iht',
    },
    {
      icon: 'mdi-google-classroom',
      title: 'Kelola Pendampingan oleh IN',
      subtitle: 'Instruktur ad Interim',
      desc: 'Kelola Kelompok Pendampingan Komite Pembelajar',
      color: 'indigo',
      deepColor: '',
      akses: false,
      key: 'diklat-kp',
      link: 'diklat-kp',
      to: { name: 'diklat-pendampingan' },
    },
    {
      icon: 'mdi-file-clock-outline',
      title: 'Laporan Pelaksanaan IHT',
      subtitle: '',
      desc: 'Laporan Berkalan dan Laporan Pelaksanaan',
      color: 'indigo',
      deepColor: 'darken-1',
      akses: false,
      key: 'diklat-iht',
      disable: false,
      action: 'diklat-iht',
    },
    {
      key: 'lokakarya-gtk',
      icon: 'mdi-account-group',
      title: 'Laporan Pendampingan Kelompok',
      desc: 'Kelola Laporan Pendampingan Kelompok',
      color: 'orange',
      deepColor: '',
      akses: true,
      to: { name: 'kp-lokakarya' },
    },
    {
      key: 'laporan-lingkup-pendidikan',
      icon: 'mdi-account-group',
      title: 'Laporan Lingkup Satuan Pendidikan',
      subtitle: 'Sekolah Penggerak',
      desc: 'Kelola Laporan Lingkup Satuan Pendidikan',
      color: 'orange',
      deepColor: 'darken-2',
      akses: false,
      to: { name: 'laporan-lingkup-pendidikan' },
    },
    {
      icon: 'mdi-file-clock',
      title: 'Umpan Balik Kegiatan Pendampingan',
      subtitle: '',
      desc: 'Anda memiliki tugas untuk mengisikan umpan balik pada Kegiatan Pendampingan Kelompok',
      color: 'orange',
      deepColor: 'darken-1',
      btnText: 'Isi umpan balik',
      akses: true,
      key: 'feedback',
      disable: false,
      to: { name: 'diklat-feedback' },
    },
    {
      icon: 'mdi-file-clock',
      title: 'Rekapan Lembar Umpan Balik Kegiatan Pendampingan',
      subtitle: '',
      desc: 'Anda memiliki tugas untuk mengisikan rekapan lembar umpan balik pada Kegiatan Pendampingan Kelompok',
      color: 'red',
      deepColor: 'darken-1',
      btnText: 'Isi rekapan lembar umpan balik',
      akses: true,
      key: 'rekap-lokakarya',
      disable: false,
      to: { name: 'rekap-lokakarya' },
    },
    {
      key: 'pkp-peserta',
      icon: 'mdi-account-multiple',
      title: 'Daftar Guru dan Pengawas',
      subtitle: 'Sekolah Anda',
      desc:
        'Persiapan daftar Guru dan Pengawas sebagai perwakilan dari Sekolah untuk mengikuti Pelatihan Komite Pembelajaran (PKP)',
      color: 'green',
      deepColor: 'lighten-1',
      btnText: 'Cek Daftar Guru dan Pengawas',
      akses: false,
      link: 'pkp-peserta',
      to: { name: 'pkp-peserta' },
    },
    {
      key: 'pengimbasan-peserta',
      icon: 'mdi-account-multiple',
      title: 'Peserta Pelatihan Pengimbasan',
      subtitle: 'Sekolah Anda',
      desc: 'Pemilihan data Guru sebagai perwakilan dari Sekolah untuk mengikuti Pelatihan Pengimbasan',
      color: 'blue',
      deepColor: 'lighten-1',
      akses: false,
      link: 'pengimbasan-peserta',
      to: { name: 'pengimbasan-peserta' },
    },
    {
      key: 'modul-pengimbasan',
      icon: 'mdi-file-document-multiple',
      title: 'Modul dan Materi Pengimbasan',
      desc: 'Daftar Modul dan Materi Pengimbasan',
      color: 'purple darken-1',
      deepColor: '',
      akses: false,
    },
    {
      key: 'sertifikat',
      icon: 'mdi-certificate-outline',
      title: 'Daftar Sertifikat',
      desc: 'Daftar Sertifikat',
      color: 'success',
      deepColor: '',
      akses: false,
      link: 'sertifikat',
      to: { name: 'sertifikat' },
    },
    {
      icon: 'mdi-web',
      title: 'Portal Sekolah Penggerak',
      desc: '',
      color: 'secondary',
      deepColor: 'darken-2',
      dividerTop: true,
      sidebar: true,
      akses: true,
      newtab: true,
      href: '#PORTAL_URL#',
    },
    {
      icon: 'mdi-webhook',
      title: 'ke Aplikasi SIMPKB',
      desc: '',
      color: 'secondary',
      deepColor: 'darken-2',
      sidebar: true,
      akses: true,
      link: 'app-sim-pkb',
      href: '#SIM_PKB_URL#',
    },
  ],
  3: [
    {
      key: 'biodata-fsp',
      icon: 'mdi-briefcase-account-outline',
      title: 'Profil Fasilitator',
      desc:
        'Pada tahap ini anda diwajibkan untuk melengkapi semua informasi Biodata Diri Anda sesuai dengan data saat ini',
      color: 'green',
      deepColor: '',
      akses: true,
      disable: false,
      to: { name: 'biodata-fsp' },
    },
    {
      key: 'berkas-tambahan-fsp',
      icon: 'mdi-file-plus',
      title: 'Berkas Dokumen Tambahan',
      desc: 'Merupakan berkas dokumen tambahan sebagai penunjang informasi peserta',
      color: 'pink',
      deepColor: 'darken-1',
      akses: true,
      to: { name: 'berkas-tambahan-fsp' },
    },
    {
      key: 'modul-pendampingan',
      icon: 'mdi-file-document-multiple',
      title: 'Modul Perangkat Pendampingan',
      desc: 'Modul Perangkatan Pendampingan untuk FSP',
      color: 'purple darken-1',
      deepColor: '',
      akses: false,
      to: { name: 'modul-pendampingan' },
    },
    {
      key: 'kinerja',
      icon: 'mdi-format-list-checks',
      title: 'Evaluasi Kinerja',
      desc:
        'Modul evkin ini digunakan untuk menilai terhadap kinerja yang telah dilakukan oleh setiap peran dalam Program Sekolah Penggerak terhadap peran lainnya.',
      color: 'indigo darken-1',
      deepColor: '',
      akses: false,
      disable: false,
      link: 'kinerja',
      to: { name: 'kinerja' },
    },
    {
      key: 'dkp-pa',
      icon: 'mdi-google-classroom',
      title: 'Laporan PMO & Pendampingan Individu',
      desc: 'Kelola Kelompok Pendampingan oleh PA',
      color: 'indigo',
      deepColor: '',
      akses: true,
      to: { name: 'pendampingan' },
    },
    // {
    //   // key: 'diklat',
    //   icon: 'mdi-google-classroom',
    //   title: 'Bimbingan Teknis',
    //   desc: 'Tautan menuju Laman Bimbingan Teknis',
    //   color: 'primary',
    //   deepColor: '',
    //   akses: true,
    //   disable: true,
    //   href: '#LMS_URL#',
    // },

    {
      icon: 'mdi-file-check-outline',
      title: 'Laporan PMO Sekolah',
      subtitle: '',
      desc: 'Laporan Berkala kegiatan PMO',
      color: 'orange',
      deepColor: 'darken-1',
      akses: false,
      key: 'laporan-pmo-sekolah',
      link: 'laporan-pmo-sekolah',
      to: { name: 'laporan-pmo-sekolah' },
    },
    {
      icon: 'mdi-file-clock-outline',
      title: 'Laporan Pelaksanaan IHT',
      subtitle: '',
      desc: 'Laporan Berkalan dan Laporan Pelaksanaan',
      color: 'indigo',
      deepColor: 'darken-1',
      akses: false,
      key: 'iht',
      disable: false,
      action: 'iht',
    },
    {
      icon: 'mdi-google-classroom',
      title: 'Kelola Pendampingan oleh IN',
      subtitle: 'Instruktur ad Interim',
      desc: 'Kelola Kelompok Pendampingan Komite Pembelajar',
      color: 'indigo',
      deepColor: '',
      akses: false,
      key: 'diklat-kp',
      link: 'diklat-kp',
      to: { name: 'diklat-pendampingan' },
    },
    {
      icon: 'mdi-file-clock-outline',
      title: 'Laporan Pelaksanaan IHT',
      subtitle: '',
      desc: 'Laporan Berkalan dan Laporan Pelaksanaan',
      color: 'indigo',
      deepColor: 'darken-1',
      akses: false,
      key: 'diklat-iht',
      disable: false,
      action: 'diklat-iht',
    },
    {
      key: 'lokakarya-gtk',
      icon: 'mdi-account-group',
      title: 'Laporan Pendampingan Kelompok',
      desc: 'Kelola Laporan Pendampingan Kelompok',
      color: 'orange',
      deepColor: '',
      akses: true,
      to: { name: 'kp-lokakarya' },
    },
    {
      key: 'laporan-lingkup-pendidikan',
      icon: 'mdi-account-group',
      title: 'Laporan Lingkup Satuan Pendidikan',
      subtitle: 'Sekolah Penggerak',
      desc: 'Kelola Laporan Lingkup Satuan Pendidikan',
      color: 'orange',
      deepColor: 'darken-2',
      akses: false,
      to: { name: 'laporan-lingkup-pendidikan' },
    },
    {
      key: 'pkp-peserta',
      icon: 'mdi-account-multiple',
      title: 'Daftar Guru dan Pengawas',
      subtitle: 'Sekolah Anda',
      desc:
        'Persiapan daftar Guru dan Pengawas sebagai perwakilan dari Sekolah untuk mengikuti Pelatihan Komite Pembelajaran (PKP)',
      color: 'green',
      deepColor: 'lighten-1',
      btnText: 'Cek Daftar Guru dan Pengawas',
      akses: false,
      link: 'pkp-peserta',
      to: { name: 'pkp-peserta' },
    },
    {
      key: 'pengimbasan-peserta',
      icon: 'mdi-account-multiple',
      title: 'Peserta Pelatihan Pengimbasan',
      subtitle: 'Sekolah Anda',
      desc: 'Pemilihan data Guru sebagai perwakilan dari Sekolah untuk mengikuti Pelatihan Pengimbasan',
      color: 'blue',
      deepColor: 'lighten-1',
      akses: false,
      link: 'pengimbasan-peserta',
      to: { name: 'pengimbasan-peserta' },
    },
    {
      key: 'modul-pengimbasan',
      icon: 'mdi-file-document-multiple',
      title: 'Modul dan Materi Pengimbasan',
      desc: 'Daftar Modul dan Materi Pengimbasan',
      color: 'purple darken-1',
      deepColor: '',
      akses: false,
    },
    {
      key: 'diklat',
      icon: 'mdi-google-classroom',
      title: 'Diklat PSP',
      desc: 'Tautan menuju Laman Diklat Program Sekolah Penggerak',
      color: 'primary',
      deepColor: '',
      akses: true,
      href: '#LMS_URL#',
    },
    {
      key: 'sertifikat',
      icon: 'mdi-certificate-outline',
      title: 'Daftar Sertifikat',
      desc: 'Daftar Sertifikat',
      color: 'success',
      deepColor: '',
      akses: false,
      link: 'sertifikat',
      to: { name: 'sertifikat' },
    },
    {
      icon: 'mdi-web',
      title: 'Portal Sekolah Penggerak',
      desc: '',
      color: 'secondary',
      deepColor: 'darken-2',
      dividerTop: true,
      sidebar: true,
      akses: true,
      newtab: true,
      href: '#PORTAL_URL#',
    },
    {
      icon: 'mdi-webhook',
      title: 'ke Aplikasi SIMPKB',
      desc: '',
      color: 'secondary',
      deepColor: 'darken-2',
      sidebar: true,
      akses: true,
      link: 'app-sim-pkb',
      href: '#SIM_PKB_URL#',
    },
  ],
  unregister: [
    {
      key: 'biodata-fsp',
      icon: 'mdi-briefcase-account-outline',
      title: 'Profil Fasilitator',
      desc:
        'Pada tahap ini anda diwajibkan untuk melengkapi semua informasi Biodata Diri Anda sesuai dengan data saat ini',
      color: 'green',
      deepColor: '',
      akses: true,
      disable: false,
      to: { name: 'biodata-fsp' },
    },
    {
      key: 'berkas-tambahan-fsp',
      icon: 'mdi-file-plus',
      title: 'Berkas Dokumen Tambahan',
      desc: 'Merupakan berkas dokumen tambahan sebagai penunjang informasi peserta',
      color: 'pink',
      deepColor: 'darken-1',
      akses: true,
      to: { name: 'berkas-tambahan-fsp' },
    },
    {
      key: 'modul-pendampingan',
      icon: 'mdi-file-document-multiple',
      title: 'Modul Perangkat Pendampingan',
      desc: 'Modul Perangkatan Pendampingan untuk FSP',
      color: 'purple darken-1',
      deepColor: '',
      akses: false,
      to: { name: 'modul-pendampingan' },
    },
    {
      key: 'kinerja',
      icon: 'mdi-format-list-checks',
      title: 'Evaluasi Kinerja',
      desc:
        'Modul evkin ini digunakan untuk menilai terhadap kinerja yang telah dilakukan oleh setiap peran dalam Program Sekolah Penggerak terhadap peran lainnya.',
      color: 'indigo darken-1',
      deepColor: '',
      akses: false,
      disable: false,
      link: 'kinerja',
      to: { name: 'kinerja' },
    },
    {
      icon: 'mdi-file-check-outline',
      title: 'Laporan PMO Sekolah',
      subtitle: '',
      desc: 'Laporan Berkala kegiatan PMO',
      color: 'orange',
      deepColor: 'darken-1',
      akses: false,
      key: 'laporan-pmo-sekolah',
      link: 'laporan-pmo-sekolah',
      to: { name: 'laporan-pmo-sekolah' },
    },
    {
      key: 'dkp-pa',
      icon: 'mdi-google-classroom',
      title: 'Laporan PMO & Pendampingan Individu',
      desc: 'Kelola Kelompok Pendampingan oleh PA',
      color: 'indigo',
      deepColor: '',
      akses: false,
      to: { name: 'pendampingan' },
    },
    {
      key: 'diklat',
      icon: 'mdi-google-classroom',
      title: 'Diklat PSP',
      desc: 'Tautan menuju Laman Diklat Program Sekolah Penggerak',
      color: 'primary',
      deepColor: '',
      akses: true,
      href: '#LMS_URL#',
    },
    {
      icon: 'mdi-file-clock-outline',
      title: 'Laporan Pelaksanaan IHT',
      subtitle: '',
      desc: 'Laporan Berkalan dan Laporan Pelaksanaan',
      color: 'indigo',
      deepColor: 'darken-1',
      akses: false,
      key: 'iht',
      disable: false,
      action: 'iht',
    },
    {
      icon: 'mdi-google-classroom',
      title: 'Kelola Pendampingan oleh IN',
      subtitle: 'Instruktur ad Interim',
      desc: 'Kelola Kelompok Pendampingan Komite Pembelajar',
      color: 'indigo',
      deepColor: '',
      akses: false,
      key: 'diklat-kp',
      link: 'diklat-kp',
      to: { name: 'diklat-pendampingan' },
    },
    {
      icon: 'mdi-file-clock-outline',
      title: 'Laporan Pelaksanaan IHT',
      subtitle: '',
      desc: 'Laporan Berkalan dan Laporan Pelaksanaan',
      color: 'indigo',
      deepColor: 'darken-1',
      akses: false,
      key: 'diklat-iht',
      disable: false,
      action: 'diklat-iht',
    },
    {
      key: 'lokakarya-gtk',
      icon: 'mdi-account-group',
      title: 'Laporan Pendampingan Kelompok',
      desc: 'Kelola Laporan Pendampingan Kelompok',
      color: 'orange',
      deepColor: '',
      akses: false,
      to: { name: 'kp-lokakarya' },
    },
    {
      key: 'laporan-lingkup-pendidikan',
      icon: 'mdi-account-group',
      title: 'Laporan Lingkup Satuan Pendidikan',
      subtitle: 'Sekolah Penggerak',
      desc: 'Kelola Laporan Lingkup Satuan Pendidikan',
      color: 'orange',
      deepColor: 'darken-2',
      akses: false,
      to: { name: 'laporan-lingkup-pendidikan' },
    },
    {
      key: 'pkp-peserta',
      icon: 'mdi-account-multiple',
      title: 'Daftar Guru dan Pengawas',
      subtitle: 'Sekolah Anda',
      desc:
        'Persiapan daftar Guru dan Pengawas sebagai perwakilan dari Sekolah untuk mengikuti Diklat Komite Pembelajaran (DKP)',
      color: 'green',
      deepColor: 'lighten-1',
      btnText: 'Cek Daftar Guru dan Pengawas',
      akses: false,
      link: 'pkp-peserta',
      to: { name: 'pkp-peserta' },
    },
    {
      key: 'pengimbasan-peserta',
      icon: 'mdi-account-multiple',
      title: 'Peserta Pelatihan Pengimbasan',
      subtitle: 'Sekolah Anda',
      desc: 'Pemilihan data Guru sebagai perwakilan dari Sekolah untuk mengikuti Pelatihan Pengimbasan',
      color: 'blue',
      deepColor: 'lighten-1',
      akses: false,
      link: 'pengimbasan-peserta',
      to: { name: 'pengimbasan-peserta' },
    },
    {
      key: 'modul-pengimbasan',
      icon: 'mdi-file-document-multiple',
      title: 'Modul dan Materi Pengimbasan',
      desc: 'Daftar Modul dan Materi Pengimbasan',
      color: 'purple darken-1',
      deepColor: '',
      akses: false,
    },
    {
      key: 'sertifikat',
      icon: 'mdi-certificate-outline',
      title: 'Daftar Sertifikat',
      desc: 'Daftar Sertifikat',
      color: 'success',
      deepColor: '',
      akses: false,
      link: 'sertifikat',
      to: { name: 'sertifikat' },
    },
  ],
  lulus: [
    {
      icon: 'mdi-file',
      title: 'Surat Pernyataan Dukungan Dinas Pendidikan / Atasan',
      subtitle: '',
      desc: 'Pada langkah ini Anda diharuskan melengkapi dokumen surat pernyataan dukungan dinas pendidikan / atasan',
      color: 'blue',
      deepColor: 'darken-1',
      akses: false,
      key: 'atasan',
      disable: false,
      to: { name: 'pimpinan' },
    },
    {
      key: 'diklat',
      icon: 'mdi-google-classroom',
      title: 'Diklat PSP',
      desc: 'Tautan menuju Laman Diklat Program Sekolah Penggerak',
      color: 'primary',
      deepColor: '',
      akses: true,
      href: '#LMS_URL#',
    },
    {
      key: 'kinerja',
      icon: 'mdi-format-list-checks',
      title: 'Evaluasi Kinerja',
      desc:
        'Modul evkin ini digunakan untuk menilai terhadap kinerja yang telah dilakukan oleh setiap peran dalam Program Sekolah Penggerak terhadap peran lainnya.',
      color: 'indigo darken-1',
      deepColor: '',
      akses: false,
      disable: false,
      link: 'kinerja',
      to: { name: 'kinerja' },
    },
    {
      icon: 'mdi-file-check-outline',
      title: 'Laporan PMO Sekolah',
      subtitle: '',
      desc: 'Laporan Berkala kegiatan PMO',
      color: 'orange',
      deepColor: 'darken-1',
      akses: false,
      key: 'laporan-pmo-sekolah',
      link: 'laporan-pmo-sekolah',
      to: { name: 'laporan-pmo-sekolah' },
    },
    {
      icon: 'mdi-file-clock-outline',
      title: 'Laporan Pelaksanaan IHT',
      subtitle: '',
      desc: 'Laporan Berkalan dan Laporan Pelaksanaan',
      color: 'indigo',
      deepColor: 'darken-1',
      akses: false,
      key: 'iht',
      disable: false,
      action: 'iht',
    },
    {
      icon: 'mdi-google-classroom',
      title: 'Kelola Pendampingan oleh IN',
      subtitle: 'Instruktur ad Interim',
      desc: 'Kelola Kelompok Pendampingan Komite Pembelajar',
      color: 'indigo',
      deepColor: '',
      akses: false,
      key: 'diklat-kp',
      link: 'diklat-kp',
      to: { name: 'diklat-pendampingan' },
    },
    {
      icon: 'mdi-file-clock-outline',
      title: 'Laporan Pelaksanaan IHT',
      subtitle: '',
      desc: 'Laporan Berkalan dan Laporan Pelaksanaan',
      color: 'indigo',
      deepColor: 'darken-1',
      akses: false,
      key: 'diklat-iht',
      disable: false,
      action: 'diklat-iht',
    },
    {
      icon: 'mdi-file-clock',
      title: 'Umpan Balik Kegiatan Pendampingan',
      subtitle: '',
      desc: 'Anda memiliki tugas untuk mengisikan umpan balik pada Kegiatan Pendampingan Kelompok',
      color: 'orange',
      deepColor: 'darken-1',
      btnText: 'Isi umpan balik',
      akses: true,
      key: 'feedback',
      disable: false,
      to: { name: 'diklat-feedback' },
    },
    {
      icon: 'mdi-file-clock',
      title: 'Rekapan Lembar Umpan Balik Kegiatan Pendampingan',
      subtitle: '',
      desc: 'Anda memiliki tugas untuk mengisikan rekapan lembar umpan balik pada Kegiatan Pendampingan Kelompok',
      color: 'red',
      deepColor: 'darken-1',
      btnText: 'Isi rekapan lembar umpan balik',
      akses: true,
      key: 'rekap-lokakarya',
      disable: false,
      to: { name: 'rekap-lokakarya' },
    },
    {
      key: 'pkp-peserta',
      icon: 'mdi-account-multiple',
      title: 'Daftar Guru dan Pengawas',
      subtitle: 'Sekolah Anda',
      desc:
        'Persiapan daftar Guru dan Pengawas sebagai perwakilan dari Sekolah untuk mengikuti Diklat Komite Pembelajaran (DKP)',
      color: 'green',
      deepColor: 'lighten-1',
      btnText: 'Cek Daftar Guru dan Pengawas',
      akses: false,
      link: 'pkp-peserta',
      to: { name: 'pkp-peserta' },
    },
    {
      key: 'pkp-pengawas',
      icon: 'mdi-account-multiple',
      title: 'Ajuan Pengawas PKP 2',
      subtitle: 'Sekolah Penggerak',
      desc: 'Data Ajuan Pengawas PKP',
      color: 'indigo',
      deepColor: '',
      btnText: 'Ajukan Pengawas',
      akses: false,
      link: 'pkp-pengawas',
      to: { name: 'pkp-pengawas' },
    },
    {
      key: 'pengimbasan-peserta',
      icon: 'mdi-account-multiple',
      title: 'Peserta Pelatihan Pengimbasan',
      subtitle: 'Sekolah Anda',
      desc: 'Pemilihan data Guru sebagai perwakilan dari Sekolah untuk mengikuti Pelatihan Pengimbasan',
      color: 'blue',
      deepColor: 'lighten-1',
      akses: false,
      link: 'pengimbasan-peserta',
      to: { name: 'pengimbasan-peserta' },
    },
    {
      key: 'modul-pengimbasan',
      icon: 'mdi-file-document-multiple',
      title: 'Modul dan Materi Pengimbasan',
      desc: 'Daftar Modul dan Materi Pengimbasan',
      color: 'purple darken-1',
      deepColor: '',
      akses: false,
    },
    {
      key: 'sertifikat',
      icon: 'mdi-certificate-outline',
      title: 'Daftar Sertifikat',
      desc: 'Daftar Sertifikat',
      color: 'success',
      deepColor: '',
      akses: false,
      link: 'sertifikat',
      to: { name: 'sertifikat' },
    },
    {
      icon: 'mdi-web',
      title: 'Portal Sekolah Penggerak',
      desc: '',
      color: 'secondary',
      deepColor: 'darken-2',
      dividerTop: true,
      sidebar: true,
      akses: true,
      newtab: true,
      href: '#PORTAL_URL#',
    },
    {
      icon: 'mdi-webhook',
      title: 'ke Aplikasi SIMPKB',
      desc: '',
      color: 'secondary',
      deepColor: 'darken-2',
      sidebar: true,
      akses: true,
      link: 'app-sim-pkb',
      href: '#SIM_PKB_URL#',
    },
  ],
};
